<template>
  <div class="plan-item-1">
    <div class="paper">
      <img
        class="clip-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b4bd15072dddbbffdd4ccbb4938b2253.png"
        alt=""
      />
      <!-- 减脂方案 -->
      <div class="my-plan">
        <div class="my-plan-top">
          <div class="plan-name">我的减脂方案</div>
        </div>
        <div class="t-list">
          <div class="t-item" v-for="(item, index) in highlights" :key="index">
            <img
              class="icon-image"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b73061ba66b852cf15c3fd7159835615.png"
              alt=""
            />
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
      <!-- 用户信息 -->
      <div class="info-container">
        <div class="info-item info-item-left">
          <div class="info-title">昵称</div>
          <div class="info-text nickname-content"
            ><img
              class="avatar"
              :src="data.brief_data.user_info.head_img"
              alt=""
            /><span class="nickname">{{
              data.brief_data.user_info.truename
            }}</span></div
          >
        </div>
        <div class="info-item">
          <div class="info-title">生理性别</div>
          <div class="info-text">{{
            data.brief_data.user_info.gender == 1 ? '男' : '女'
          }}</div>
        </div>
        <div class="info-item info-item-left">
          <div class="info-title">年龄</div>
          <div class="info-text" v-if="data.brief_data.user_info.age"
            >{{ data.brief_data.user_info.age }}岁</div
          >
        </div>
        <div class="info-item">
          <div class="info-title">BMI指数</div>
          <div class="info-text">{{ data.brief_data.user_info.bmi }}</div>
        </div>
      </div>
      <!-- 预计减重 -->
      <div class="less-info">
        <div class="less-item">
          <div class="less-title">预计减重效果</div>
          <div class="less-text less-num"
            >{{ data.brief_data.prev_lose_weight.lose_section }}斤</div
          >
        </div>
        <div class="less-item">
          <div class="less-title">针对性改善</div>
          <div class="less-text">{{
            data.brief_data.prev_lose_weight.improve_body_part
          }}</div>
          <div class="less-desc">（按体型灵活调整）</div>
        </div>
        <div class="less-item less-other">
          <div class="less-title">其他预计效果</div>
          <div class="other-text">{{
            data.brief_data.prev_lose_weight.other_effect
          }}</div>
        </div>
      </div>
      <!--  -->
      <div class="method-desc">{{ data.brief_data.plan_authority }}</div>
      <div
        class="coach-info"
        v-if="data.brief_data.expert_info"
        @click="bindToCoachDetail"
      >
        <img
          class="coach-avatar"
          :src="data.brief_data.expert_info.head_portrait"
          alt=""
        />
        <div class="coach-center">
          <div class="coach-desc"
            ><span class="coach-name">{{
              data.brief_data.expert_info.name
            }}</span
            ><span>| 计划联合制订人</span></div
          >
          <div class="coach-introdution">{{
            data.brief_data.expert_info.sub_title
          }}</div>
        </div>
        <img
          class="coach-autograph"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cbab3103dc29eb479916fa6b5ec7ccc9.png"
          alt=""
        />
      </div>
      <div class="tips">*{{ data.brief_data.plan_desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      highlights: ['一人一方', 'CRD+HPD饮食干预模式', '营养师定制']
    }
  },
  created() {},
  methods: {
    bindToCoachDetail() {
      if (this.$betterwe.isApp()) {
        let id = this.data.brief_data.expert_info.dietitian_id
        this.$betterwe.jumpRoute(`/dietitianDetails?id=${id}&isLogin=1`)
      } else {
        this.$router.push('/app-download')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-item-1 {
  color: rgb(48, 48, 56);
  padding-bottom: 7px;
  box-shadow: 0px 3px 5px 0px rgba(146, 143, 238, 0.22);
  border-radius: 4px;
  .paper {
    position: relative;
    padding: 40px 20px 13px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/43a79ae5d089fb13864b0afc0002c05a.png');
    background-color: rgb(251, 251, 251);
    background-size: 100%;
    background-repeat: repeat-y;
    border: 1px solid #ffffff;
    border-radius: 4px;
    .clip-image {
      width: 137px;
      position: absolute;
      left: 50%;
      top: -7px;
      transform: translate(-50%, 0%);
    }
    .my-plan {
      margin-bottom: 17px;
      position: relative;
      padding-bottom: 14px;
      border-bottom: 1.5px solid rgba(0, 0, 0, 0.7);

      .my-plan-top {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;

        .plan-name {
          font-weight: bold;
          font-size: 28px;
          line-height: 40px;
          text-shadow: 0px 3px 5px rgba(146, 143, 238, 0.22);
        }
      }

      .t-list {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: rgba(48, 48, 56, 0.5);
        font-size: 10px;
        line-height: 14px;
        text-shadow: 0px 3px 5px rgba(146, 143, 238, 0.22);

        .t-item {
          position: relative;
          display: flex;
          align-items: center;
          padding: 0px 10px;

          .icon-image {
            margin-right: 2px;
            width: 10px;
            height: 10px;
          }
        }

        .t-item::after {
          content: '';
          position: absolute;
          right: 0px;
          top: 50%;
          transform: translate(0%, -50%);
          width: 1px;
          height: 10px;
          color: rgba(48, 48, 56, 0.2);
        }

        .t-item:last-child::after {
          display: none;
        }
      }
    }

    .my-plan::after {
      content: '';
      left: 0;
      bottom: -4px;
      position: absolute;
      width: 100%;
      height: 0.5px;
      background-color: rgba(48, 48, 56, 0.3);
    }

    .info-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 4px;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);
      margin-bottom: 13px;

      .info-item {
        width: 140px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        margin-bottom: 9px;

        .info-title {
          margin-right: 10px;
          font-family: PingFangSC, PingFang SC;
          font-size: 13px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 18px;
        }

        .info-text {
          font-weight: bold;
          font-size: 13px;
          line-height: 18px;
          .avatar {
            display: inline-block;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            overflow: hidden;
            object-fit: cover;
            margin-right: 7px;
          }
          .nickname {
            display: inline-block;
            max-width: 100px;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        .nickname-content {
          display: flex;
          align-items: center;
        }
      }
      .info-item-left {
        width: 160px;
      }
    }

    .less-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 14px;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);
      margin-bottom: 13px;

      .less-item {
        width: 132px;
        .less-title {
          font-size: 13px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 18px;
          margin-bottom: 7px;
        }

        .less-text {
          font-weight: bold;
          font-size: 22px;
          line-height: 28px;
          margin-bottom: 4px;
        }

        .less-desc {
          font-size: 10px;
          color: rgba(48, 48, 56, 0.7);
          line-height: 14px;
          transform: translateX(-6px);
        }

        .less-num {
          font-family: MiSans, MiSans;
        }
      }

      .less-other {
        width: 100%;
        margin-top: 16px;
        .other-text {
          font-weight: bold;
          font-size: 13px;
          line-height: 20px;
        }
      }
    }

    .method-desc {
      font-size: 10px;
      color: rgba(48, 48, 56, 0.5);
      line-height: 16px;
      margin-bottom: 14px;
    }

    .coach-info {
      margin-bottom: 14px;
      background: #eff0f1;
      border-radius: 4px;
      padding: 10px 4px 10px 12px;
      display: flex;
      align-items: center;
      .coach-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 8px;
      }
      .coach-introdution {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .coach-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 10px;
        line-height: 17px;
        .coach-desc {
          font-size: 10px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 15px;
          margin-bottom: 2px;
        }
        .coach-name {
          font-weight: bold;
          font-size: 13px;
          color: rgb(48, 48, 56);
          line-height: 18px;
          margin-right: 4px;
        }
      }
      .coach-autograph {
        width: 74px;
        object-fit: contain;
      }
    }

    .tips {
      font-size: 9px;
      color: rgba(48, 48, 56, 0.5);
      line-height: 16px;
    }
  }
}
</style>
